import dayjs from "./dayjs";

/**
 * ISO8601 形式の文字列を UTC のまま "YYYY/MM/DD HH:mm:ss" フォーマットに変換する
 * @param isoString 例: "2025-06-02T07:44:45Z"
 * @returns 例: "2025/06/02 07:44:45" （UTC のまま表示）
 */
export function formatToUtc(isoString: string): string {
    return dayjs(isoString).utc().format("YYYY/MM/DD HH:mm:ss");
}
